module.exports = __webpack_public_path__ + "static/media/closeCollapse.c6bf2cef.svg";